import React from 'react'

import Button from 'components/base/Button'
import Loading from 'components/base/Loading'
import ButtonRow from 'components/base/Button/Row'
import Form from 'components/base/Form'
import { Type as InputType } from 'components/base/Form/Input'
import InputGroup from 'components/base/Form/InputGroup'

import { Props } from './types'

const SuggestInsuranceForm: React.FC<Props> = ({
  isSubmitting,
  onSubmit,
}): React.ReactElement => {
  return (
    <Form short={true} onSubmit={onSubmit}>
      <InputGroup
        type={InputType.text}
        label='Email Address'
        name='emailAddress'
        quoteRequestField='other.suggestInsurance.email'
        rules='required|email'
      />
      <InputGroup
        type={InputType.textArea}
        label='Insurance You Are Shopping For...'
        name='comments'
        placeholder='e.g. Dental Insurance'
        quoteRequestField='other.suggestInsurance.comments'
        rules='required'
      />

      <ButtonRow>
        {(isSubmitting && (
          <Loading />
        )) || (
          <Button
            center={true}
            wide={true}
            type='submit'
          >
            Send
          </Button>
        )}
      </ButtonRow>
    </Form>
  )
}

export default SuggestInsuranceForm
